import { render, staticRenderFns } from "./FichePortraitIndex.vue?vue&type=template&id=88694a16&"
import script from "./FichePortraitIndex.vue?vue&type=script&lang=js&"
export * from "./FichePortraitIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports